(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  (() => {
    const revealCards = () => {
      const cards = document.querySelectorAll('[data-reveal-card]');
      if (!cards.length) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        cards.forEach((card) => card.classList.add('is-revealed'));
        return;
      }
      const observer = new IntersectionObserver((entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          currentObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      cards.forEach((card, index) => {
        card.style.setProperty('--catalog-reveal-delay', `${Math.min(index * 45, 260)}ms`);
        observer.observe(card);
      });
    };
    document.addEventListener('DOMContentLoaded', revealCards, { once: true });
    revealCards();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vendisor-catalog"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cards = document.querySelectorAll('.vendisor-product-card[data-reveal]');
    if (!cards.length) return;
    cards.forEach((card, index) => card.style.setProperty('--reveal-delay', `${Math.min(index * 70, 350)}ms`));
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      cards.forEach((card) => card.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        currentObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    cards.forEach((card) => observer.observe(card));
  })();

  } catch(e) { console.error(e); }
})();
})();
